import { render } from "./ConstellationIcon.vue?vue&type=template&id=45958a32&ts=true"
import script from "./ConstellationIcon.vue?vue&type=script&lang=ts"
export * from "./ConstellationIcon.vue?vue&type=script&lang=ts"

import "./ConstellationIcon.vue?vue&type=style&index=0&id=45958a32&style=true&lang=less"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__